import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  Box,
  Stack,
  TextField,
  Snackbar,
  Alert,
  DialogTitle,
  Typography,
  Autocomplete,
  Grid
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { getData } from "../../../../../../services/library";

function EdicionZona(props) {
    const [editar, setEditar] = useState(props.editar)
    const [datosRow, setDatosRow] = useState(props.datosRow)
    const [openSnack, setOpenSnack] = React.useState(false);
    const [colormensaje, setColorMensaje] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [grupos, setGrupos] = useState()
    const [grupoSeleccionado, setGrupoSeleccionado] = useState("")
    const [disbtn, setdisbtn] = useState(false)

    useEffect(() => {
      getData("/envasado_grupos_zonas/", setGrupos);
    }, [])
    
    //Snackbar Notificacion
    const handleCloseSnack = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpenSnack(false);
      handleClose()
    };

    const handleClose = () => {
        setEditar(!editar);
      if (props.onClose) {
        props.onClose();
      }
    };

    const almacenar = (e) => {
        setDatosRow({
          ...datosRow,
          [e.target.name]: e.target.value,
        });
      };

      const EditarZona = async (e) => {
          setdisbtn(true)
          e.preventDefault();
          await fetch(UrlApi + "/envasado_zona/" + datosRow.id, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              nombre: datosRow.nombre,
              descripcion: datosRow.descripcion,
              grupo: grupoSeleccionado.id,
            }),
          })
            .then((res) => {
              if (!res.err) {
                setOpenSnack(true);
                // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
                setColorMensaje("#D4EFDF");
                setMensaje("La Zona se editó exitosamente !");
                console.log("Guardado");
              } else {
                setOpenSnack(false);
                setColorMensaje("#F1948A");
                setMensaje("Error al editar la Zona");
                console.log("Error");
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
        };

    useEffect(() => {
        if (grupoSeleccionado === "") {
          if (datosRow.id_grupo !== "" && grupos) {
            const grupoEncontrado = grupos.find(
              (d) => d.id === datosRow.id_grupo
            );
            if (grupoEncontrado) {
              setGrupoSeleccionado(grupoEncontrado);
            }
          }
        }
    }, [datosRow, grupos])
        
   return (
    <>
    <Dialog
        fullWidth
        open={editar}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
     <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar Zona {datosRow.id}
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={EditarZona}>
        <DialogContent>
            {/* <Box
              backgroundColor="#F4F6F6"
              px={2}
              py={2}
              border={0.5}
              borderColor={"#ABB2B9"}
              borderRadius={3}
            > */}
              <Grid container  spacing={1}>
                <Grid item xs={3} py={1} mb={1}>
                <TextField
                    label="Nombre"
                    name="nombre"
                    size="small"
                    placeholder="..."
                    inputProps={{
                      maxLength: 100,
                    }}
                    focused
                    required
                    fullWidth
                    value={datosRow.nombre}
                    onChange={almacenar}
                  />
                </Grid>
                <Grid item xs={9} py={1} mb={1}>
                <TextField
                    label="Descripción"
                    name="descripcion"
                    size="small"
                    placeholder="..."
                    inputProps={{
                      maxLength: 300,
                    }}
                    focused
                    required
                    fullWidth
                    value={datosRow.descripcion}
                    onChange={almacenar}
                  />
                </Grid>
                <Grid item xs={12}>
              <Autocomplete
                disabled={!grupos}
                required
                disableClearable
                id="grupo"
                size="small"
                noOptionsText={"grupo INEXISTENTE"}
                options={grupos}
                autoHighlight
                getOptionLabel={(grupo) =>
                  grupo.id + "-" + grupo.nombre
                }
                isOptionEqualToValue={(option, value) =>
                  option.id === value?.id
                }
                value={grupoSeleccionado || null}
                defaultValue={grupoSeleccionado || null}
                onChange={(event, value) => {
                  setGrupoSeleccionado(value);
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    key={option.id}
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                  >
                    {option.id} - {option.nombre}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    placeholder="Tipee para buscar..."
                    {...params}
                    label="Grupo"
                    focused
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
              />
            </Grid>
              </Grid>
              <Grid container direction="row" justifyContent="space-between" mt={1}>
                <Grid item>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => handleClose()}
                    style={{ backgroundColor: "#fff" }}
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="submit"
                    color="success"
                    variant="contained"
                    disabled={disbtn}
                    // endIcon={<SaveIcon />}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
           {/* </Box> */}
        </DialogContent>
            </form>
    </Dialog>

    <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
  </>
  )
}

export default EdicionZona